var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !!_vm.communities.length
    ? _c("div", { staticClass: "c-article__reposted" }, [
        _c("h5", [_vm._v("Reposted to:")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "c-communities__wrapper c-communities__wrapper--article",
            attrs: { id: "reposted" },
          },
          _vm._l(_vm.communities, function (community) {
            return _c("div", { staticClass: "c-communities__tile" }, [
              _c("a", { attrs: { href: "/" + community.url } }, [
                _c("img", {
                  staticClass: "c-communities__img",
                  attrs: {
                    src: _vm.$simpleStore.cloudinaryUrl(
                      210,
                      210,
                      "img/communities/" +
                        community.community_id +
                        "/" +
                        community.image,
                      _vm.$root
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "c-communities__name" }, [
                _c("a", { attrs: { href: "/" + community.url } }, [
                  _vm._v(_vm._s(community.name)),
                ]),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm.communities.length > 5
          ? _c("div", { staticClass: "c-article__more-btn" }, [
              _c("a", { staticClass: "c-btn3", attrs: { href: "#0" } }, [
                _vm._v("More"),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }